import { useSyncExternalStore } from 'react';

// Two routes (`/` and `/<code>`) don't justify a router dependency.
const listeners = new Set<() => void>();

function subscribe(fn: () => void) {
  listeners.add(fn);
  window.addEventListener('popstate', fn);
  return () => {
    listeners.delete(fn);
    window.removeEventListener('popstate', fn);
  };
}

export function navigate(path: string, { replace = false } = {}) {
  if (replace) history.replaceState(null, '', path);
  else history.pushState(null, '', path);
  listeners.forEach((fn) => fn());
}

export function usePathname(): string {
  return useSyncExternalStore(subscribe, () => location.pathname);
}
